import { render, staticRenderFns } from "./Prodetails.vue?vue&type=template&id=0e9dd40a&scoped=true&"
import script from "./Prodetails.vue?vue&type=script&lang=js&"
export * from "./Prodetails.vue?vue&type=script&lang=js&"
import style0 from "./Prodetails.vue?vue&type=style&index=0&id=0e9dd40a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e9dd40a",
  null
  
)

export default component.exports